module.exports = __webpack_public_path__ + "img/pencil-round.35e36a28.svg";